import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DataService {

  private sellPermission = new BehaviorSubject<boolean>(false);
  private buyPermission = new BehaviorSubject<boolean>(true);

  sellPerm = this.sellPermission.asObservable();
  buyPerm = this.buyPermission.asObservable();

  updateBuyPerm(data:any){
    this.buyPermission.next(data);
  }

  updateSellPerm(data:any){
    this.sellPermission.next(data)
  }


  constructor() { }
}
